import { Component, ChangeDetectionStrategy } from '@angular/core';

import { HttpProgressService } from '../../services/http-progress.service';

@Component({
    selector: 'app-progress-bar',
    imports: [],
    template: `
    @if (progressService.isLoading()) {
      <div class="progress-bar-container">
        <div class="progress-bar"></div>
      </div>
    }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`
    .progress-bar-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 9999;
      background: transparent;
    }
    .progress-bar {
      height: 100%;
      background: #94A5B7;
      animation: progress 1.5s ease-in-out infinite;
    }
    @keyframes progress {
      0% { width: 0; margin-left: 0; }
      50% { width: 70%; margin-left: 15%; }
      100% { width: 0; margin-left: 100%; }
    }
  `]
})
export class ProgressBarComponent {
  constructor(public progressService: HttpProgressService) {}
}
